import { API } from "aws-amplify";

export interface ChimpAPIResponse {
  statusCode: number;
  body: string;
}

export async function subscribeEmailToMailChimp(email: string) {
  const request = {
    headers: {
      "Content-Type": "application/json",
      "x-api-key": process.env.GATSBY_AMPLIFY_API_KEY,
    },
    body: {
      email: email,
    },
  };

  return await API.post("onlineMarketingStore", "/users/email", request).then(
    (res) => {
      if (res.statusCode === 200) {
        return { status: "subscribed", body: res.body };
      } else {
        return { status: "error", body: res.body };
      }
    }
  ).catch((res) => {
    return { status: "error", body: res.body };
  });
}
